/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Trade request
 */
export interface SyntheticTradeRequest {
  /**
   * Account ID.
   */
  accountId: number;
  /**
   * Trade direction.
   */
  side: SyntheticTradeRequest.SideEnum;
  /**
   * Qty for client(in base asset).
   */
  units: number;
  /**
   * First pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  baseAssetPairIds: Array<number>;
  baseAssetPairSide: SyntheticTradeRequest.BaseAssetPairSideEnum;
  /**
   * Second pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  quoteAssetPairIds: Array<number>;
  quoteAssetPairSide: SyntheticTradeRequest.QuoteAssetPairSideEnum;
  /**
   * Total for client(in quote asset).
   */
  total: number;
  /**
   * Rate for client.
   */
  clientRate: number;
  /**
   * Base asset ID.
   */
  baseAssetId: number;
  /**
   * Quote asset ID.
   */
  quoteAssetId: number;
}
export namespace SyntheticTradeRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const BaseAssetPairSideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type BaseAssetPairSideEnum = (typeof BaseAssetPairSideEnum)[keyof typeof BaseAssetPairSideEnum];
  export const QuoteAssetPairSideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type QuoteAssetPairSideEnum = (typeof QuoteAssetPairSideEnum)[keyof typeof QuoteAssetPairSideEnum];
}
